<template>
    <v-container
        fluid
        class="px-4"
        v-if="product">
        <v-row>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('ticketAndAddOns.productDetails.productId')"/>
                <v-text-field
                    outlined
                    disabled
                    hide-details
                    height="40px"
                    v-model="product.id"/>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('ticketAndAddOns.productDetails.productType')"/>
                <v-text-field
                    outlined
                    disabled
                    hide-details
                    height="40px"
                    v-model="product.productType"/>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('ticketAndAddOns.productDetails.productName')"/>
                <v-text-field
                    outlined
                    disabled
                    hide-details
                    height="40px"
                    v-model="product.productName"/>
            </v-col>
            <v-col cols="6">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('ticketAndAddOns.productDetails.price')"/>
                <v-text-field
                    outlined
                    disabled
                    reverse
                    hide-details
                    height="40px"
                    v-model="product.price"/>
            </v-col>
            <v-col cols="12">
                <div
                    class="subtitle-2 font-weight-bold"
                    v-html="$t('ticketAndAddOns.productDetails.description')"/>
                <v-text-field
                    outlined
                    disabled
                    hide-details
                    height="40px"
                    v-model="product.description"/>
            </v-col>
        </v-row>
    </v-container>
    <div v-else></div>
</template>

<script>
export default {
    name: 'ProductDetailsView',

    props: {
        product: {
            type: Object,
            default: () => null
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
